angular.module('rjmNg.directives').directive "sqlCalculationInput", [
  () ->
    restrict: "E"
    templateUrl: "directive.sqlCalculationInput.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      columnInputs: "="
      table: "="
      sql: "="
      datatype: "="
    controller: [
      "stringService"
      "sql"
      "encodedLetterString"
      "sqlService"
      "Columns"
      "dataWarehouse"
      "$sce"
      (
        stringService
        sql
        encodedLetterString
        sqlService
        Columns
        dataWarehouse
        $sce
      ) ->

        view = @

        TEST_LIMIT = 5

        view.queryStatus = ""
        view.queryResult = []
        view.queryResultHeader = []

        view.runTestQuery = () ->
          Columns.getCollection().then( (cols) ->
            inputColumns = _getInputColumns(view.columnInputs, cols)
            if sqlService.canValidateQuery(inputColumns)
              _runQuery()
            else
              view.queryStatus = "We're unable to run a test query, because one of your inputs is a calculated column. You can still save and use this column in reports."
              view.queryResult = []
          )

        _runQuery = () ->
          view.queryResult = []
          view.queryResultHeader = []
          view.testQuery = sqlService.getTestQuery(view.sql, view.columnInputs, view.table, TEST_LIMIT)
          sql.run(view.testQuery).then( handleTestQuerySuccess, handleTestQueryFailure)

        _getInputColumns = (inputs, cols) ->
          inputIds = view.columnInputs.map (input) -> input.column
          cols.filter (col) -> col.id in inputIds

        handleTestQuerySuccess = (result) ->
          if result.data.data.error
            handleTestQueryFailure(result)
          else
            view.queryStatus = ""
            view.queryResult = result.data.data.body
            view.queryResultHeader = result.data.data.header

        handleTestQueryFailure = (result) ->
          view.queryStatus = result.data.data.error
          view.queryResult = []

        # This allows us to display special characters properly like '&><`
        view.strToTrustedHtml = (str) ->
          # string interpolation is important here
          # because trustAsHtml will fail on non-string values
          return $sce.trustAsHtml("#{str}")

        view.DATA_TYPES = _.values(dataWarehouse.DATA_TYPES)

        view.getDataTypeNameById = (id) ->
          for dataType in view.DATA_TYPES
            if dataType.id is id
              return dataType.name
          return id

        @$onInit = ->
          view.columnInputs ?= []
          for input in view.columnInputs
            unless input.table?
              input.table = view.table

        return view
    ]
]
